import React, { useEffect, useState } from 'react';
import { Button, Box, Grid, Tabs, Tab, IconButton, Modal, Dialog, DialogContent, DialogActions, Chip, Checkbox, Select, MenuItem } from '@mui/material';
import { req } from './ServerUtils';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const ApproveTemplates = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
      setActiveTab(newValue);
  };

  return (
    <div>
        <Tabs value={activeTab} onChange={handleChange}>
            <Tab label="UnApproved Template" />
            <Tab label="All Templates" />
        </Tabs>
        <div>
            {activeTab === 0 && <div><Templates approved={false}/></div>}
            {activeTab === 1 && <div><Templates /></div>}
        </div>
    </div>
  )
}
const Templates = ({approved}) => {
  const [templates, setTemplates] = useState([]);
  const [page, setPage] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);

  useEffect(() => {
    loadMore();
  }, []);

  function loadMore() {
    let url = `/admin/html_templates?page=${page + 1}`
    if (approved == true || approved == false) {
      url += `&approved=${approved}`;
    }
    req(url).then(data => {
      setTemplates([...templates, ...data.templates]);
      setPage(page + 1);
    });
    
  }

  const handleApproval = (templateId, approved) => {
    req('/admin/approve', 'POST', JSON.stringify({ template_id: templateId, is_approved: approved }))
      .then(response => {
        setTemplates(templates.map(template => {
          if (template.id === templateId) {
            template.approved = approved;
          }
          return template;
        }));
    });
  };

  const [category, setCategory] = useState();
  const [designerEmail, setDesignerEmail] = useState();
  const [designerEmails, setDesignerEmails] = useState([]);

  useEffect(() => {
    req('/admin/designers').then(data => setDesignerEmails(data));
  }, [])

  return (
    <Box p={3}>
      <div style={{
        marginBottom: 20,
        display: 'flex',
        justifyContent: 'center',
      }}>
        {['mako-carousel', 'carousel', 'listicle', 'a_vs_b', 'linkedin-banner'].map((cat, i) => (
          <Chip key={i} label={cat} style={{
            margin: 5,
            cursor: 'pointer',
            backgroundColor: cat === category ? 'purple' : '#ccc',
            color: cat === category ? 'white' : 'black',
          }} onClick={() => {
            setCategory(cat)
          }}/>
        ))}

        <Select value={designerEmail} onChange={e => setDesignerEmail(e.target.value)}>
          <MenuItem value="">All Designers</MenuItem>
          {designerEmails.map(email => (
            <MenuItem key={email} value={email}>{email}</MenuItem>
          ))}
        </Select>


      </div>
      <div className="row">
        {templates.map(template => !template.archived && (!category || template.category == category) && (
          designerEmail ? template.designer_email === designerEmail : true
        ) && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 20,
              border: "1px solid black",
              padding: 20,
              borderRadius: 10,
            }}>
              <div>
                {template.id}
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <img src={template.inspiration} alt="Template Preview" style={{ 
                  width: "100%",
                  height: 300,
                  objectFit: 'contain',
                  cursor: "pointer"
                }} 
                onClick={() => window.open('/template/' + template.id, '_blank')}
                />

                {!template.previews && (
                  <img src={template.preview} alt="Template Preview" style={{ 
                    width: "100%",
                    height: 300,
                    objectFit: 'cover',
                    cursor: "pointer"
                  }} 
                  onClick={() => window.open('/template/' + template.id, '_blank')}
                  />
                )}

                {template?.previews?.length > 1 && (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row'
                  }}>
                    {template.previews.map((preview, i) => (
                      <img key={i} src={preview} alt="Template Preview" style={{ 
                        width: 300,
                        height: 300,
                        objectFit: 'cover',
                        cursor: "pointer"
                      }} 
                      onClick={() => window.open('/template/' + template.id, '_blank')}
                      />
                    ))}
                  </div>
                )}
                
                <div style={{
                  display: 'flex',
                  gap: 20,
                  alignItems: 'center',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}>                
                  <a href={'https://app.makemybrand.ai/design/' + template.id + '-sample'} target="_blank">Sample</a>

                  {!template.approved && (
                    <IconButton onClick={() => {
                      setDeleteOpen(template.id);
                    }} style={{color: "#db9191"}}>
                      <DeleteOutlineIcon />
                    </IconButton>)}
                </div>
              </div>
              <Button
                variant="outlined"
                style={{ textTransform: 'none', color: template.approved ? 'red' : 'limegreen', borderColor: template.approved ? 'red' : 'limegreen' }}
                onClick={() => handleApproval(template.id, !template.approved)}
                >
                {template.approved ? "Unapprove" : "Approve"}
              </Button>
            </div>
         ))} 
      </div>
      <div style={{
        textAlign: 'center',
        marginTop: 20,
      }}>
        <Button variant="outlined" color="primary" onClick={loadMore}>Load More</Button>
      </div>


      <Dialog open={Boolean(deleteOpen)} onClose={() => setDeleteOpen(null)}>
        <DialogContent>
            <div>Are you sure you want to delete template {deleteOpen}?</div>
        </DialogContent>
        <DialogActions>
          <Button 
              color="red"
              onClick={() => {
                req('/admin/delete_template', 'DELETE', JSON.stringify({ template_id: deleteOpen }))
                .then(res => {
                  
                  setTemplates(templates.filter(template => template.id !== deleteOpen));
                })
                console.log('delete', deleteOpen);
                setDeleteOpen(false);
              }}>Yes</Button>
              <Button onClick={() => setDeleteOpen(false)}>No</Button>
            
        </DialogActions>
      </Dialog> 
    </Box>
  );
};

export default ApproveTemplates;
